<template>
  <div>
    <h1 class="text-4xl uppercase text-center pb-1.5 md:pb-3.5 md:pt-6">news</h1>
    <hr />
    <div class="flex justify-between flex-wrap mt-4 md:mt-11">
      <div class="w-full md:basis-3/4 flex-wrap flex justify-start mb-2 sm:mb-0 text-tiny">
        <NuxtLink
          v-for="year in years"
          :key="year.value"
          :to="'/news/year/' + year.value + '/' + entryType"
          class="
            text-darkRed
            pr-1.5
            underline underline-offset-1
            hover:text-darkBlue
             mx-1
          "
          :class="{ 'font-bold': year.isActive }"
          >{{ year.label }}</NuxtLink
        >
      </div>
      <div class="w-full md:basis-1/4 flex justify-center	 sm:justify-end text-tiny">
        <span class="px-1.5 text-grayMedium font-tiny">Show:</span>
        <div
          class="text-darkRed hover:text-darkBlue underline underline-offset-1 font-tiny"
          >Story
        </div>
<!--        <span class="px-1.5">|</span>-->
<!--        <NuxtLink-->
<!--          :href="'/news/year/' + activeYear + '/headlines'"-->
<!--          class="text-darkRed hover:text-darkBlue underline underline-offset-1 font-tiny"-->
<!--          :class="{ 'font-bold': entryType == 'headlines' }"-->
<!--        >-->
<!--          Headlines</NuxtLink-->
<!--        >-->
      </div>
    </div>
    <template v-if="ready">
      <NewsItem
        :title="news.entry_title"
        :content="news.entry_content"
        :key="news.id"
        :showContinueLink="news.showContinueLink"
        :entryUri="news.entry_uri"
        :date="news.created_at"
        :type="entryType"
        v-for="news in newsItems"
    /></template>
    <template v-else v-for="n in 5" :key="n">
      <NewsLoader />
    </template>
    <Pagination
      :numberOfPages="numberOfPages"
      v-model:currentPage="currentPage"
    />
  </div>
</template>
<script>
export default {
  name: "NewsPage",
};
</script>
<script setup>
import { http } from "~/utils/http";
import {ref, watch} from "vue";
import {useHead} from "nuxt/app";
import {useSiteTitle} from "~/composables/state";

const siteTitle = useSiteTitle();
const route = useRoute();
const newsFilters = route.params.newsFilters;
const entryType = ref(null);
const activeYear = ref(null);

const ready = ref(false);
const newsItems = ref(false);
const years = ref(false);
const numberOfPages = ref(false);
const status = ref(null);
const message = ref("");
const currentPage = ref(route.query.page);

const getPages = async () => {
  try {
    await http
        .get("/api/pages/get-page", {
          params: {
            permalink: 'news',
          }
        })
        .then((response) => {
          if (response.data.page != null) {

              useHead({
                title: response.data.page.meta_title + ' - ' + siteTitle.value,
                meta: [
                  {name: 'description', content:response.data.page.meta_description},
                  {name: 'keywords', content: response.data.page.meta_keywords}
                ],
              })

          }
        });
  } catch (e) {
  }
}

const getNews = async () => {
  try {
    await http
      .get("/api/news", {
        params: {
          year: activeYear.value,
          newsType: entryType.value,
          page: currentPage.value,
        },
      })
      .then((json) => {
        status.value = json.data.status;
        message.value = json.data.message;
        newsItems.value = json.data.news.data;
        years.value = json.data.years;
        entryType.value = json.data.show;
        activeYear.value = json.data.currentYear;
        numberOfPages.value = json.data.news.last_page;
        currentPage.value = json.data.news.current_page;
        ready.value = true;
      });
  } catch (e) {}
};

if (newsFilters.length === 3) {
  activeYear.value = newsFilters[1];
  entryType.value = newsFilters[2];
  getPages();
}

getNews();

watch(currentPage, () => {
  getNews();
});
</script>
